import React, { useEffect, useContext, useState } from "react";
import { TeamManagementContext } from "./teammanagementContext"
import { getAgentDetails, setAttendanceRule } from './service'
import useApi from "../../hooks/useApi";
import Dropdown from 'react-dropdown';
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss"
import FormInput from "../../uicomponents/form-input/forminput";
import FutworkButton from "../../uicomponents/button";
import checkIsEmpty from "../../helper/checkIsEmpty";
import { InfoIcon } from "../../assets/images";
import moment from "moment";

const criteraParameter = [
    // {label: 'Not Connected Attempts (count)', value: 'notConnectedAttempts'},
    {label: 'Connected Attempts (count)', value: 'connectedAttempts'},
    {label: 'Spoken Min (in minutes)', value: 'spokenMin'},
    {label: 'Working Time (in hrs & mins)', value: 'productiveTime'},
    {label: 'Call Attempts (count)', value: '(connectedAttempts + notConnectedAttempts)'}
]

const hoursList = [
    {label: '0 Hr', value: 0},
    {label: '1 Hr', value: 1},
    {label: '2 Hrs', value: 2},
    {label: '3 Hrs', value: 3},
    {label: '4 Hrs', value: 4},
    {label: '5 Hrs', value: 5},
    {label: '6 Hrs', value: 6},
    {label: '7 Hrs', value: 7},
    {label: '8 Hrs', value: 8},
    {label: '9 Hrs', value: 9},
    {label: '10 Hrs', value: 10}
]

const minuteList = [
    {label: '00 Min', value: 0},
    {label: '30 Mins', value: 30}
]

const AttendanceCriteria = (props) => {
    const { teamSelected } = useContext(TeamManagementContext)
    const [attendanceCriteriaData, setAttendanceCriteria] = useState('')
    const [criteriaParameterSelected, setCriteriaParameterSelected] = useState({
        parameter: '',
        threshold: ''
    })
    const [apiMsg, setApiMsg] = useState({
        type: '',
        msg: ''
    })
    const [inputAdded, setInputAdded] = useState(false)
    const [attendanceCriteriaActionTaken, setAttendanceCriteriaActionTaken] = useState("")
    const [duration, setDuration] = useState({
        hours: 0,
        mins: 0,
        totalsecs: 0
    })

    useEffect(() => {
        const {agent} = teamSelected || {}
        fetchUserDetails(agent)
    }, [])

    const fetchUserDetails = async(agent) => {
        try {
            const result = await getAgentDetails(agent.mobile)
            if(result && result.attendanceCriteriaMeta){
                if(result.attendanceCriteriaMeta.criteriaUpdatedAt){
                    setAttendanceCriteriaActionTaken(moment(result.attendanceCriteriaMeta.criteriaUpdatedAt).format('DD-MM-YYYY hh:mm A'))
                }
                // split to identify parameter and threshold
                const splitArray = result.attendanceCriteriaMeta.criteria.split('>=')
                const [first, last] = splitArray
                // Match: [parameter] >= [value]
                // const match = result.attendanceCriteria.match(/(\w+)\s*>=\s*(\d+)/);
                if (splitArray) {
                    const parameter = first.trim()
                    // match[1]; // dynamic parameter
                    const threshold = last.trim()
                    // match[2]; // dynamic threshold
                    setAttendanceCriteria({
                        parameter: parameter,
                        threshold: threshold
                    })
                    setCriteriaParameterSelected({
                         parameter: parameter,
                         threshold: threshold
                    })
                    if(parameter == 'productiveTime'){
                        let seconds = threshold ; // or "2000"
                        seconds = parseInt(seconds) //because moment js dont know to handle number in string format
                        let format =  Math.floor(moment.duration(seconds,'seconds').asHours()) + ':' + moment.duration(seconds,'seconds').minutes() + ':' + moment.duration(seconds,'seconds').seconds();
                        setDuration({
                            hours: Math.floor(moment.duration(seconds,'seconds').asHours()),
                            mins: moment.duration(seconds,'seconds').minutes(),
                            totalsecs: seconds
                        })
                        
                    }
                }
            }
        } catch (error) {
            console.error(error.response)
        }
       
    }

    const validateThreshold = () => {
        if(criteriaParameterSelected.threshold == ''){
            setApiMsg({
                type: 'error',
                msg: `Please add threshold value`
            })
            return false
        }
        else if(/^\d*$/.test(criteriaParameterSelected.threshold)){
            // Valid: only digits or empty
            setApiMsg({
                type: '',
                msg: ''
            })
            return true
        }
        else{
            setApiMsg({
                type: 'error',
                msg: `Invalid threshold value`
            })
            return false
        }
    }

    const setCriteria = async () => {
        if (!validateThreshold()) {
            return; // 🚫 Do not proceed
        }
        // ✅ Continue with the form submission
        const {agent} = teamSelected || {}
        const payload = {
            "userId": agent.id,
            "attendanceCriteria": `${criteriaParameterSelected.parameter} >= ${criteriaParameterSelected.threshold}`
            // "string (expression, required)"
        }

        try {
            const result = await setAttendanceRule(payload)
            if(result.status == 200){
                setApiMsg({
                    type: 'success',
                    msg: result && result.data && result.data.msg ? 
                    result.data.msg : `Attendance criteria updated successfully`
                })
            }
        } catch (error) {
            console.error(error.response)
            const {data} = error.response
            setApiMsg({
                type: 'error',
                msg: data && data.error ? data.error : `Something went wrong`
            })
        }finally{
            setInputAdded(false)
            // setTimeout(() => {
            //     props.setShowAttendanceCriteria(false)
            // }, 500);
        }
    }

    const checkIfWorkingTimeParameter = () => {
        const lookupForValue = 'productiveTime'
        if(criteriaParameterSelected.parameter == lookupForValue) return true
        else return false
    }

    
    const selectedMins = minuteList.find(({value}) => value === duration.mins) ? minuteList.find(({value}) => value === duration.mins) : minuteList[0]
    const selectedHrs = hoursList.find(({value}) => value === duration.hours) ? hoursList.find(({value}) => value === duration.hours) : hoursList[0]

    return (
        <div>
        <div className={styles['dotted-border']}>
            <div>
                <b>Parameter</b>
                <Dropdown
                options={criteraParameter}
                onChange={(e) => {
                    if(!inputAdded)setInputAdded(true)
                    setCriteriaParameterSelected({
                        ...criteriaParameterSelected,
                        parameter: e.value
                    })
                    setApiMsg({
                        type: '',
                        msg: ''
                    })
                }}
                placeholder="Select parameter"
                className={styles['paramter_dropdown']}
                value={criteraParameter.find(({ value }) => criteriaParameterSelected.parameter == value) ? criteriaParameterSelected.parameter : ''}
                />
            </div>
            <div>
                <b>Threshold Values</b>
                {
                    checkIfWorkingTimeParameter() ?
                    <div style={{display: 'flex', gap: '0.5em'}}>
                    <Dropdown
                    options={hoursList}
                    onChange={(e) => {
                    if(!inputAdded)setInputAdded(true)
                    const convetHrsToSeconds = e.value * 3600
                    const convertMinsToSeconds = duration.mins * 60
                    const totalsecs = convetHrsToSeconds + convertMinsToSeconds
                    setDuration({
                        ...duration,
                        hours: e.value,
                        totalsecs
                    })
                    setCriteriaParameterSelected({
                        ...criteriaParameterSelected,
                        threshold: totalsecs
                    })
                    if(e.value > 0){
                        setApiMsg({
                            type: '',
                            msg: ''
                        })
                    }
                    }}
                    placeholder="Select Hr(s)"
                    className={styles['threshold_dropdown']}
                    value={selectedHrs}
                    />
                    <Dropdown
                    options={minuteList}
                    onChange={(e) => {
                    if(!inputAdded)setInputAdded(true)
                    const convetHrsToSeconds = duration.hours * 3600
                    const convertMinsToSeconds = e.value * 60
                    const totalsecs = convetHrsToSeconds + convertMinsToSeconds
                    setDuration({
                        ...duration,
                        mins: e.value,
                        totalsecs
                    })
                    setCriteriaParameterSelected({
                        ...criteriaParameterSelected,
                        threshold: totalsecs
                    })
                    }}
                    placeholder="Select Min(s)"
                    className={styles['threshold_dropdown']}
                    value={selectedMins}
                    />
                    </div>
                    : 
                    <FormInput 
                    helperIcon={false}
                    type="number"
                    key={'threshold'}
                    onChange={(e) => {
                        if(!inputAdded)setInputAdded(true)
                        setCriteriaParameterSelected({
                            ...criteriaParameterSelected,
                            threshold: e.target.value
                        })
                        if(e.target.value == ''){
                            setApiMsg({
                                type: '',
                                msg: ''
                            })
                        }
                    }}
                    value={criteriaParameterSelected.threshold}
                    />
                }
               
            </div>
        </div>
        {attendanceCriteriaActionTaken ? <div>Criteria last updated on: {attendanceCriteriaActionTaken}</div> : null}
        <div className={styles['user-note']}>
        <img src={InfoIcon} width={"18px"}/> For advanced configurations, raise an MT request.
        </div>
        <div className={styles['criteria-footer']}>
                <div className={styles['first-child']}>
                {
                    !checkIsEmpty(apiMsg) ?
                        <div className={apiMsg.type == 'success' ?
                            styles['success-msg'] : styles['error-msg']}>{apiMsg.msg}</div>
                    : <div></div>
                }
                </div>

                <div className={styles['second-child']}>
                <FutworkButton buttonStyle="primary--outline non-rounded" buttonSize="sm">Cancel</FutworkButton>
                <FutworkButton buttonStyle='navy--solid non-rounded' buttonSize="sm" onClick={() => setCriteria()}disabled={!inputAdded ? true : false}>Submit</FutworkButton>
                </div>
        </div>
        </div>
    )
}

export default AttendanceCriteria